// @flow

import isObject from 'lodash/isObject';

import { STORAGE_PREFIX } from '../constants';

export default class SlingStorage {
  static getItem(key: string, defaultValue: Object | null = null): Object | string | null {
    let value;

    try {
      value = localStorage.getItem(`${STORAGE_PREFIX}${key}`);
      if (typeof value === 'undefined' || value === null) {
        return defaultValue;
      }
    } catch (e) {
      return defaultValue;
    }

    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  static setItem(key: string, value: Object | string | null): void {
    const item = isObject(value) ? JSON.stringify(value) : value;
    localStorage.setItem(`${STORAGE_PREFIX}${key}`, (item: any)); // we're guarded by isObject above
  }
}
